import { REWARDS_BASE_URL } from "./ApiConfig";

/**
 * Service for handling rewards-related API operations
 */
const RewardsService = {
  /**
   * Find unsynced rewards for the user
   * @param {string} firebaseToken - The Firebase authentication token
   * @returns {Promise<Array>} - Array of unsynced rewards
   */
  findUnsyncedRewards: async (firebaseToken) => {
    try {
      if (!firebaseToken) {
        throw new Error("Firebase token is required");
      }

      const url = `${REWARDS_BASE_URL}/api/omig/find-unsynced-rewards`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${firebaseToken}`,
          "x-user-token": firebaseToken,
        },
      });

      if (!response.ok) {
        throw new Error(`Server responded with status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error in findUnsyncedRewards:", error);
      throw error;
    }
  },

  /**
   * Import unsynced rewards for the user
   * @param {string} firebaseToken - The Firebase authentication token
   * @returns {Promise<Object>} - Import result
   */
  importUnsyncedRewards: async (firebaseToken) => {
    try {
      if (!firebaseToken) {
        throw new Error("Firebase token is required");
      }

      const url = `${REWARDS_BASE_URL}/api/omig/import-unsynced-rewards`;

      // Get user ID from session storage - try different possible keys

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${firebaseToken}`,
          "x-user-token": firebaseToken,
        },
      });

      if (!response.ok) {
        throw new Error(`Server responded with status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error in importUnsyncedRewards:", error);
      throw error;
    }
  },
};

export default RewardsService;
